import { Stack } from '@mui/material';
import {
  BackupJobType,
  RestoreJob,
  type BackupJob,
  type ScanJob,
} from '@repo/api-gw-sdk';

import { useEnvironment } from '@/contexts/useEnvironment';

import TemporalIcon from '../../../public/statics/images/apps/temporal.png';
import { CopyToClipboardWrapper } from '../buttons/copyToClipboardButton';
import { CircleImage } from '../shared/circleImage';
import { TextLink } from '../shared/textLink';

export const TemporalLinkField = ({
  entity,
}: {
  entity: BackupJob | RestoreJob | ScanJob;
}) => {
  const { isDev } = useEnvironment();

  const getTemporalBaseUrl = () => {
    if (isDev) {
      return 'http://localhost:37670';
    }
    if (location.host.endsWith('testing-console.eon.io')) {
      return 'https://temporal.testing-infra.eon.io';
    }
    if (location.host.endsWith('console.app.eon.io')) {
      return 'https://temporal.prod-infra.app.eon.io';
    }
    return 'https://temporal.prod-infra.eon.io';
  };

  const getTemporalNamespace = () => {
    if (entity instanceof RestoreJob) {
      return 'restore';
    }

    return 'inventory';
  };

  const fullScanJobTypes: string[] = [
    BackupJobType.AwsDynamoDbBackupFull,
    BackupJobType.AtlasMongodbClusterBackupFull,
    BackupJobType.AwsKeyspacesBackupFull,
  ];

  const getWorkflowId = () => {
    const jobId = entity.jobExecutionDetails.jobId;
    if (
      'backupType' in entity &&
      entity.backupType &&
      fullScanJobTypes.includes(entity.backupType)
    ) {
      return `${jobId}${encodeURIComponent('/FullScan')}`;
    }
    return jobId;
  };

  return (
    <CopyToClipboardWrapper textToCopy={entity.jobExecutionDetails.jobId}>
      <Stack direction='row' alignItems='center' gap='8px'>
        <CircleImage src={TemporalIcon} alt='temporal' />
        <TextLink
          target='_blank'
          href={`${getTemporalBaseUrl()}/namespaces/${getTemporalNamespace()}/workflows/${getWorkflowId()}`}
        >
          {entity.jobExecutionDetails.jobId}
        </TextLink>
      </Stack>
    </CopyToClipboardWrapper>
  );
};
